export const TASK_SERVICE_STORE = 'TASK_SERVICE_STORE';
export const TASK_SERVICE_UPDATE = 'TASK_SERVICE_UPDATE';
export const TASK_SERVICE_DESTROY = 'TASK_SERVICE_DESTROY';
